import { css } from "@emotion/css";

export const unauthorizedMessageStyle = css`
    margin: 30px 0;
    text-align: left;
`;

export const unauthorizedImageWrapperStyle = css`
    &.camkit-icon {
        border-radius: 0%;
    }
`;
